<template>
    <!--编辑档案弹窗-->
    <td-dialog width="650px" :title="$t('workFlowProcessAudit.EDIT_AUDIT')" :visible.sync="dialogVisible" :before-close="dialogClose" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form ref="form" :inline="true" :model="form" :rules="rules" labelWidth="90px">
            <el-form-item :label="$t('pgCommon.USERNAME')" prop="sUserName">
                <td-input v-model="form.sUserName" disabled></td-input>
            </el-form-item>
            <el-form-item :label="$t('workFlowProcessAudit.ORG_STRUCT')" prop="sOrgName">
                <td-select v-model="form.sOrgName" disabled></td-select>
            </el-form-item>
            <el-form-item v-for="(item, index) in expandResources" :key="index" :label="item.sRemark" :prop="item.sName">
                <td-select v-model="item.sLabelId" :options="item.labelList" keys="sId" text="sRemark"></td-select>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <td-button type="primary" :loading="submitLoading" @click="save">{{ $t('pgCommon.SAVE') }}</td-button>
            <td-button @click="dialogClose">{{ $t('pgCommon.CANCEL') }}</td-button>
        </div>
    </td-dialog>
</template>

<script>
import Api from '@/modules/workFlowFileConfiguration/assets/api';

export default {
    name: 'editFileDialog',
    props: ['dialogVisible', 'data'],
    data() {
        return {
            submitLoading: false,
            form: {
                sUserName: '',
                sOrgName: '',
                area: '',
                productType: ''
            },
            rules: {},
            expandResources: []
        };
    },
    created() {
        this.initExpandResource();
        this.initFormRules();
    },
    methods: {
        //初始化扩展资源信息
        initExpandResource() {
            this.expandResources = this.data.expandResources;
            this.form.sUserName = this.data.sUserName;
            this.form.sOrgName = this.data.sOrgName;
            let auditRelateVoList = {};
            try {
                auditRelateVoList = JSON.parse(JSON.stringify(this.data.auditRelateVoList));
            } catch (e) {
                console.log('Json conversion failed', e);
            }
            auditRelateVoList.forEach(item => {
                this.expandResources.forEach((element, i) => {
                    if (element.sId === item.sLabelGroupId) {
                        this.expandResources[i].sLabelId = item.sLabelId;
                    }
                });
            });
        },
        //初始化表单校验规则
        initFormRules() {
            let validatePass = [];
            this.expandResources.forEach((item, index) => {
                validatePass[index] = (rule, value, callback) => {
                    if (this.$util.isEmpty(item.sLabelId)) {
                        callback(new Error(this.$t('pgCommon.PLEASE_INPUT')));
                    } else {
                        callback();
                    }
                };
                this.rules[item.sName] = [{ required: true, validator: validatePass[index], trigger: 'blur' }];
            });
        },
        save() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.submitLoading = true;
                    console.dir(this.data);
                    let params = { sId: this.data.sId, sUserId: this.data.sUserId, sAuditGroupId: this.data.sAuditGroupId };
                    let auditRelateVoList = [];
                    this.expandResources.forEach((item, index) => {
                        this.data.auditRelateVoList.forEach((element, i) => {
                            if (item.sId === element.sLabelGroupId) {
                                let obj = {};
                                obj.sId = element.sId;
                                obj.sLabelId = item.sLabelId;
                                try {
                                    auditRelateVoList.push(JSON.parse(JSON.stringify(obj)));
                                } catch (e) {
                                    console.log('Json conversion failed', e);
                                }
                            }
                        });
                    });
                    params.auditRelateVoList = auditRelateVoList;
                    Api.updateFileInfo(params, response => {
                        this.submitLoading = false;
                        if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                            this.$log.error('/auditManage/updateAudit', response);
                            return;
                        }
                        if (response.data.statusCode !== 'API-COMMON-INF-OK') {
                            this.$message({ type: 'error', showClose: true, message: this.$t('workFlowProcessAudit.EDIT_AUDIT_FAIL') });
                        } else {
                            this.$message({ type: 'success', showClose: true, message: this.$t('workFlowProcessAudit.EDIT_AUDIT_SUCCESS') });
                            this.dialogClose();
                        }
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        dialogClose() {
            this.$emit('dialogClose');
        }
    }
};
</script>

<style scoped></style>
